export function resolveSalesOrderApproveBlockedHint(input: {
  isApproving?: boolean;
  canEditOrder: boolean;
  editLockHolderDisplayName?: string | null;
  validationMessages: string[];
  unsavedChangesHint?: string | null;
}): string | null {
  if (input.isApproving === true) {
    return null;
  }
  if (input.unsavedChangesHint != null && input.unsavedChangesHint.trim() !== "") {
    return input.unsavedChangesHint;
  }
  if (!input.canEditOrder) {
    const holder = input.editLockHolderDisplayName?.trim() ?? "";
    if (holder !== "") {
      return `${holder} currently controls editing for this order. Take over editing to approve.`;
    }
    return "Editing access has not been secured yet. Wait for the edit lock or refresh the page.";
  }
  if (input.validationMessages.length === 0) {
    return null;
  }
  return input.validationMessages.join("\n\n");
}
